module.exports = __webpack_public_path__ + "static/media/right.bfbd1167.jpg";